import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import "./style/App.css";
import Login from "./admin/Login";
import Admin from "./admin/Admin";
import Start from "./pages/Start";
import Company from "./admin/Company";
import { ToastContainer, toast } from "react-toastify";
import QStart from "./pages/QStart";
import MaintenancePage from "./pages/MaintenancePage";
import { I18nProvider } from "@/i18n/I18nProvider";
import { TestTakerI18nProvider } from "@/i18n/TestTakerI18nProvider";
import HelpDetailPage from "./pages/HelpDetailPage";
import ChecklistRatingHarness from "./pages/ChecklistRatingHarness";

const FLASH_ERROR_KEY = "AppFlashError";

export default function App() {
  const location = useLocation();
  const isMaintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE === 'true';

  useEffect(() => {
    const flashError = window.sessionStorage.getItem(FLASH_ERROR_KEY);
    if (flashError) {
      toast.error(flashError);
      window.sessionStorage.removeItem(FLASH_ERROR_KEY);
    }
  }, [location.pathname, location.search]);

  if (isMaintenanceMode) {
    return <MaintenancePage />;
  }
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="Admin" element={<I18nProvider><Admin /></I18nProvider>} />
        <Route path="Company/:companyIdStr" element={<I18nProvider><Company /></I18nProvider>} />
        <Route path="Start/:code" element={<TestTakerI18nProvider><Start /></TestTakerI18nProvider>} />
        <Route path="Welcome/:code?" element={<TestTakerI18nProvider><Start /></TestTakerI18nProvider>} />
        <Route path="Login" element={<Login />} />
        <Route path="HelpDetail/:helpContentId" element={<HelpDetailPage />} />
        <Route path="QStart" element={<QStart />} />
        <Route path="r" element={<QStart />} />
        <Route path="q" element={<QStart />} />
        {import.meta.env.DEV ? (
          <Route path="e2e/checklist-rating" element={<ChecklistRatingHarness />} />
        ) : null}
      </Routes>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );

}

